<template>
    <div class="database-view" v-if="datasource">
        <div class="yq-news-section-list-page-head">
            {{datasource.name}}
        </div>
        <div class="clear"></div>
        <div class="gengduo">
            <news-query :datasource="datasource" @search="search">
                <template slot="ops">
                    <el-button type="primary" @click="addRow">添加</el-button>
                </template>
            </news-query>
            <div v-if="data">
                <news-list :data="data.content" :datasource="datasource" view-name="list"
                           @show-details="showDetails" ops-width="120" fix-ops>
                    <el-table-column label="是否删除" width="80">
                        <span slot-scope="scope">
                            {{scope.row.source.deleted?'是':'否'}}
                        </span>
                    </el-table-column>
                    <el-table-column label="编审用户" width="80">
                        <span slot-scope="scope">
                            {{scope.row.source.editorUser?scope.row.source.editorUser.name:''}}
                        </span>
                    </el-table-column>
                    <el-table-column label="编审时间" width="120">
                        <pretty-date-time slot-scope="scope" :value="scope.row.source.editTime"></pretty-date-time>
                    </el-table-column>
                    <template slot="ops" slot-scope="scope">
                        <el-link v-if="!scope.row.source.deleted" @click="editRow(scope.row)">修改</el-link>
                        <el-link v-if="!scope.row.source.deleted" @click="deleteRow(scope.row)">删除</el-link>
                        <el-link v-if="scope.row.source.deleted" @click="restoreRow(scope.row)">恢复</el-link>
                    </template>
                </news-list>
            </div>
            <div class="magin10"></div>
            <div class="foot" v-if="data">
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1"
                        @current-change="fetchData($event)">
                </el-pagination>
            </div>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改记录':'添加记录'" :visible.sync="dialogFormVisible">
            <news-form ref="form" :data="model" :datasource="datasource"></news-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import newsEditService from '../../service/news-edit'
    import datasourceConfigService from '../../service/datasource-config'
    import NewsList from './NewsList'
    import NewsQuery from './NewsQuery'
    import NewsForm from './NewsForm'
    import qs from 'qs'

    export default {
        name: "DataAdminNewsList",
        props: {
            datasourceId: Number
        },
        components: {NewsList, NewsQuery, NewsForm},
        data(){
            return {
                datasource: null,
                data: null,
                query: null,
                dialogFormVisible: false,
                model: null
            }
        },
        created() {
            this.init()
        },
        watch:{
            datasourceId(){
                this.init()
            }
        },
        methods: {
            async init() {
                const datasource = (await datasourceConfigService.getDatasourceConfig(this.datasourceId)).data
                datasource.fields = JSON.parse(datasource.fields)
                this.datasource = datasource
                await this.fetchData(1)
            },
            async fetchData(page) {
                const params = {
                    datasourceId: this.datasourceId,
                    page: page - 1,
                    size: 10
                }
                if(this.query){
                    params.query = this.query
                }
                const response = await newsEditService.listNews(params)
                this.data = response.data
            },
            search(query){
                this.query = query
                this.fetchData(1)
            },
            showDetails(id){
                const url  = document.location.origin + document.location.pathname + '#/main/news-details'
                const params = {
                    id,
                    datasourceId: this.datasourceId,
                }
                window.open(url+'?'+qs.stringify(params, {arrayFormat: 'repeat'}), '_blank')
            },
            addRow(){
                this.model = {
                    id: null,
                    source: null
                }
                this.dialogFormVisible = true
            },
            editRow(row){
                newsEditService.getNewsDetails({datasourceId: this.datasourceId, id: row.id}).then(response => {
                    this.model = response.data
                    this.dialogFormVisible = true
                })
            },
            submitForm(){
                this.$refs.form.validate().then(() => {
                    const model = {id:this.model.id, source:this.$refs.form.getModel()}
                    if (model.id) {
                        newsEditService.updateNews({datasourceId: this.datasourceId}, model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                        })
                    } else {
                        newsEditService.addNews({datasourceId: this.datasourceId}, model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '添加失败!'
                            })
                        })
                    }
                }).catch(()=>{})
            },
            deleteRow(row){
                this.$confirm('确定要删除该记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    newsEditService.deleteNews({datasourceId: this.datasourceId, id: row.id}).then(()=>{
                        this.fetchData(this.data.number+1)
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(()=>{
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
            },
            restoreRow(row){
                this.$confirm('确定要恢复该记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    newsEditService.restoreNews({datasourceId: this.datasourceId, id: row.id}).then(()=>{
                        this.fetchData(this.data.number+1)
                        this.$message({
                            type: 'success',
                            message: '恢复成功!'
                        })
                    }).catch(()=>{
                        this.$message({
                            type: 'error',
                            message: '恢复失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消恢复'
                    });
                })
            },

        }
    }
</script>

<style scoped>

</style>
